import React from "react";
import bannerImg from "../../../assets/Group 197.svg";
import "./banner.scss";
import { Fade } from "react-awesome-reveal";
const Banner = () => {
  return (
    <div className="banner-wrapper-content">
      <div className="banner-wrapper">
        <div className="container">
          <div
            className="banner-wrapper-image"
            style={{ position: "relative" }}
          >
            <img
              src={bannerImg}
              alt="banner"
              style={{ objectFit: "cover", width: "100%" }}
            />
            <div className="row">
              <h2>Welcome to Varrenyam</h2>
              <p className="mt-2">
                Your Premier Partner in Holistic Financial Solutions
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="our-firm">
        <div className="our-firm-content">
          <div className="container">
            <div className="row text-center">
              <div className="col-lg-8 col-md-8">
                <div
                  className="row our-firm-content-parts "
                  style={{ position: "relative", bottom: "60%" }}
                >
                  <div className="col-lg-3 col-md-6-mb4 col-sm-6 p-2">
                    <Fade direction="up">
                    <h3 className="fw-bold">50+</h3>
                    <span>Operating Companies</span>
                    </Fade>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 border-2 border-start border-light-subtle p-2">
                    <div className="verticalLine">
                    <Fade direction="up">
                      <h3 className="fw-bold">1Trillion</h3>
                      <span>
                        Combined Annual <br /> Revenues
                      </span>
                      </Fade>
                    </div>  
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-4 border-2 border-start border-light-subtle p-2">
                    <div className="verticalLine3">
                    <Fade direction="up">
                      <h3 className="fw-bold">15+</h3>
                      <span>Professionals</span>
                      </Fade>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-4 border-2 border-start border-light-subtle p-2">
                    <div className="verticalLine">
                    <Fade direction="up">
                      <h3 className="fw-bold">2002</h3>
                      <span>Founded by C.A. M K Khandelwal</span>
                      </Fade>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
